module.exports = __webpack_public_path__ + "img/zubicks.4861c636.jpg";